<template>
  <div class="p-4">
    <el-button v-if="false" class="float-right" type="primary" icon="el-icon-plus" circle size="small"
               @click="openNewPaymentMethodDialog()"></el-button>
    <el-table
      :data="payment_methods.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      style="width: 100%">
      <el-table-column
        prop="name"
        label="Name"
        sortable>
      </el-table-column>
      <el-table-column align="right" fixed="right">
        <template slot="header" slot-scope="scope">
          <el-input
            v-model="search"
            size="mini"
            placeholder="Type to search"/>
        </template>
        <template v-if="false" slot-scope="scope">
          <el-button @click="updatePaymentMethod(scope.$index, scope.row)" type="text" size="small">
            <i class="text-xl el-icon-edit-outline mr-4"></i>
          </el-button>
          <el-button @click="deletePaymentMethod(scope.$index, scope.row.id)" type="text" size="small">
            <i class="text-xl text-red-500 el-icon-delete-solid"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <PaymentMethodUpdateForm />
    <NewPaymentMethodForm />
  </div>
</template>

<script>
import { flatMap } from 'lodash';
import PaymentMethodUpdateForm from './_includes/PaymentMethodUpdateForm.vue';
import NewPaymentMethodForm from './_includes/NewPaymentMethodForm.vue';

export default {
  name: 'PaymentMethods',
  components: {
    PaymentMethodUpdateForm,
    NewPaymentMethodForm,
  },
  data() {
    return {
      search: '',
    };
  },
  computed: {
    payment_methods() {
      return flatMap(this.$store.state.SettingsModule.PaymentMethods.payment_methods);
    },
  },
  methods: {
    openNewPaymentMethodDialog() {
      this.$modal.show('new-payment-method-modal');
    },
    updatePaymentMethod(index, paymentMethod) {
      this.$modal.show('update-payment-method-modal');
      this.$store.commit('SettingsModule/PaymentMethods/setProperty', { property: 'payment_method', payload: paymentMethod });
    },
    deletePaymentMethod(index, paymentMethodId) {
      this.$confirm('Are you sure you want to delete this status?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('SettingsModule/PaymentMethods/deletePaymentMethod', { paymentMethodId });
          this.$notify.success({
            title: 'Success',
            message: 'Payment method has been deleted.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
